import React, { useEffect, useState, useTransition } from 'react';
import { OwnershipTable } from '../../UserManagement/EnterpriseModule/OwnershipTable';
import { PROPOSED_ACTIVITY_COLUMN } from './Allotment.const';
import { OWNERSHIP_TABLE_COLUMNS } from '../../UserManagement/UserManagement.const';
import { ErrorMessage, Field, FieldArray, useFormikContext } from 'formik';
import { t, use } from 'i18next';
import { getFormatedNICDetails } from './Allotment.controller';
import { getFormatedOwnershipDetails } from '../../Migration/Migration.controller';
import { SURRENDER_EXISTING_MORTGAGE_DETAILS } from '../Surrender/Surrender.const';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import GenericEmailIDNotification from '../../../../components/moduleCommonFormik/GenericEmailIDNotification.component';
import ToolTipDetails from '../../../../components/ToolTipFile';
import GenericFileUploadField from '../../../../components/moduleCommonFormik/GenericFileUpload.component';
import _ from 'lodash';
import { EMAIL_ID_FINANCIAL_INST_TOOLTIP, MORTGAGE_CHANGES_FINANCIAL_DETAILS, MORTGAGE_EXISTING_MORTGAGE_DETAILS } from '../../Mortgage Lessee/Mortgage.const';
import { useTranslation } from 'react-i18next';
import { getAdditionalDetailsForm } from '../EstateManagement.controller';
import BpaCommonSelector from '../../../../components/moduleCommonFormik/BpaCommonSelector.component';
import GenericCommonTextField from '../../../../components/moduleCommonFormik/GenericCommonTextField.component';
import { Form } from 'react-bootstrap';
import { FLOOR_TYPES } from '../../../orderCompletionScreen/OrderCompletionFormPage.module';

export const ProposedActivityReadOnly = (props: any) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const [nicDetails, setNicDetails] = useState<any>([]);

    useEffect(() => {
        (async () => {
            const newProposed = await getFormatedNICDetails(values.additionalDetails[props.index]?.response || [], {});
            setNicDetails(newProposed);
        })();
    }, []);

    return (
        <div className='ownership' key={props.index}>
            <OwnershipTable key={props.index} column={PROPOSED_ACTIVITY_COLUMN} tableRowData={nicDetails} hideSearchBar={true} isDisabled={true} scrollNotRequired={true} />
        </div>
    );
};

export const OwnershipReadOnly = (props: any) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const [ownership, setOwnership] = useState<any>([]);

    useEffect(() => {
        (async () => {
            const newOwnership = await getFormatedOwnershipDetails(values.additionalDetails[props.index]?.response, props.dropdownData);
            setOwnership(newOwnership);
        })();
    }, []);

    return (
        <div className='ownership_row' key={props.index}>
            <OwnershipTable column={OWNERSHIP_TABLE_COLUMNS} tableRowData={ownership} isDisabled={true} hideSearchBar={true} />
        </div>
    );
};

export const BankDetailReadOnly = (props: any) => {
    const { t } = useTranslation();
    const { values, setValues } = useFormikContext<any>();

    const handleEmailValues = (email: any, index: number) => {
        setValues((prevVal: any) => ({
            ...prevVal,
            additionalDetails: prevVal?.additionalDetails?.map((item: any, ind: number) => {
                if (ind === props.index) {
                    return {
                        ...item,
                        response: item?.response?.map((bankItem: any, bankInd: number) => {
                            if (bankInd === index) {
                                return { ...bankItem, notificationEmails: email };
                            } else {
                                return { ...bankItem };
                            }
                        })
                    };
                } else {
                    return { ...item };
                }
            })
        }));
    };

    return (
        <>
            {values.additionalDetails?.length && (
                <form>
                    <FieldArray name={`additionalDetails.${props.index}.response`}>
                        {({}) => (
                            <div>
                                {values.additionalDetails[props.index].response.map((data: any, bank_index: number) => (
                                    <div className='row' key={bank_index}>
                                        <div className='col-sm-12 align-items-center pb-2'>
                                            <div className='formHeading'>{`Financial Institution/Bank - ${bank_index + 1}`}</div>

                                            <div className='row d-flex m-0'>
                                                {MORTGAGE_CHANGES_FINANCIAL_DETAILS[0]?.formData.map((formField: any, id: number) => (
                                                    <div className={`py-3 col-sm-6`} key={id}>
                                                        <label htmlFor={`additionalDetails.${props.index}.response.${bank_index}.${formField.field}`} className='pb-2 file-form-label'>
                                                            {formField.title} - {bank_index + 1}
                                                            {formField.isRequired && <span className='mandatory-indicator'> *</span>}
                                                        </label>

                                                        <Field
                                                            name={`additionalDetails.${props.index}.response.${bank_index}.${formField.field}`}
                                                            type={'text'}
                                                            id={`additionalDetails.${props.index}.response.${bank_index}.${formField.field}`}
                                                            className={` form-control was-validated`}
                                                            value={_.get(values, `additionalDetails.${props.index}.response.${bank_index}.${formField.field}`)}
                                                            disabled={true}
                                                        />
                                                        <ErrorMessage name={`additionalDetails.${props.index}.response.${bank_index}.${formField.field}`}>
                                                            {msg => <span className='text-danger font-12'>{msg}</span>}
                                                        </ErrorMessage>
                                                    </div>
                                                ))}
                                                <div className='col-6 py-3'>
                                                    <GenericFileUploadField
                                                        field={`additionalDetails.${props.index}.response.${bank_index}.bankLetter`}
                                                        title={`Bank Letter`}
                                                        entityFileData={{
                                                            documentNamePrefix: `${_.get(values, `additionalDetails.${props.index}.response.${[bank_index]}.bankName`)}_Bank Letter `,
                                                            documentType: ''
                                                        }}
                                                        isRequired={true}
                                                        isDisabled={true}
                                                    />
                                                </div>

                                                <div className='px-3'>
                                                    <div className='formTitle d-flex align-items-center'>
                                                        {t('EMAIL_ID_OF_FIN_INST', 'Email id of Financial Institution')}
                                                        <ToolTipDetails toolTipDetails={EMAIL_ID_FINANCIAL_INST_TOOLTIP} />
                                                    </div>

                                                    <GenericEmailIDNotification
                                                        isEditable={false}
                                                        emailIdsData={values?.additionalDetails[props.index].response?.[bank_index]?.notificationEmails}
                                                        getEmailIds={email => handleEmailValues(email, bank_index)}
                                                        // errors={errorIndex === bank_index ? notificationError : null}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </FieldArray>
                </form>
            )}
        </>
    );
};

export const ExistingMortgageReadOnly = (props: any) => {
    const { t } = useTranslation();
    const { values, setValues } = useFormikContext<any>();

    const handleEmailValues = (email: any, index: number) => {
        setValues((prevVal: any) => ({
            ...prevVal,
            additionalDetails: prevVal?.additionalDetails?.map((item: any, ind: number) => {
                if (ind === props.index) {
                    return {
                        ...item,
                        response: item?.response?.map((bankItem: any, bankInd: number) => {
                            if (bankInd === index) {
                                return { ...bankItem, notificationEmails: email };
                            } else {
                                return { ...bankItem };
                            }
                        })
                    };
                } else {
                    return { ...item };
                }
            })
        }));
    };

    return (
        <form>
            <FieldArray name={`additionalDetails.${props.index}.response`}>
                {({}) => (
                    <div>
                        {values.additionalDetails[props.index].response?.length > 0 &&
                            values.additionalDetails[props.index].response.map((data: any, index_p: number) => (
                                <div className='row' key={index_p}>
                                    <div className='col-sm-12  align-items-center pb-2'>
                                        <div className='formHeading'>{`Financial Institution/Bank - ${index_p + 1}`}</div>
                                        <div className=' ps-1'>
                                            {getAdditionalDetailsForm(MORTGAGE_EXISTING_MORTGAGE_DETAILS, 'CLOSED').map((val: any, _: number) => (
                                                <GenericFormCard fieldPath={`additionalDetails[${props.index}].response.${index_p}`} {...val} />
                                            ))}
                                            {values?.additionalDetails[props.index].response?.[index_p]?.notificationEmails?.length > 0 ? (
                                                <div className='px-3'>
                                                    <div className='formTitle'>{t('EMAIL_ID_OF_FIN_INST', 'Email id of Financial Institution')}</div>
                                                    <GenericEmailIDNotification
                                                        isEditable={false}
                                                        emailIdsData={values?.additionalDetails[props.index].response?.[index_p]?.notificationEmails}
                                                        getEmailIds={email => handleEmailValues(email, index_p)}
                                                    />
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                )}
            </FieldArray>
        </form>
    );
};

export const NOCReadOnly = (props: any) => {
    const { values } = useFormikContext<any>();

    return (
        <>
            {values.additionalDetails?.length && (
                <form>
                    <FieldArray name={`additionalDetails.${props.index}.response`}>
                        {({}) => (
                            <div>
                                {values.additionalDetails[props.index]?.response?.length > 0 &&
                                    values.additionalDetails[props.index].response.map((data: any, index_p: number) => (
                                        <div className='row' key={index_p}>
                                            <div className='col-sm-12  align-items-center pb-2'>
                                                <div className='formHeading'>{`Financial Institution/Bank - ${index_p + 1}`}</div>
                                                <div className='ps-1'>
                                                    {SURRENDER_EXISTING_MORTGAGE_DETAILS.map((val: any, _: number) => (
                                                        <GenericFormCard fieldPath={`additionalDetails.${props.index}.response.${index_p}`} {...val} />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </FieldArray>
                </form>
            )}
        </>
    );
};

export const ExistingBlokAndFloorDetailsReadOnly = (props: any) => {
    return (
        <Form>
            <FieldArray name='blocks'>
                {({ push, remove }) => (
                    <>
                        {!!props?.floorData?.blocks &&
                            !!props?.floorData?.blocks.length &&
                            props?.floorData?.blocks.map((block: any, blockIndex: any) => (
                                <div className='my-3'>
                                    <div key={blockIndex}>
                                        <div className='d-flex'>
                                            <span className='font-inter' style={{ fontWeight: 600, fontSize: '22px', lineHeight: '32px', color: '#3a7425', marginLeft: '10px' }}>
                                                Block - {blockIndex + 1}
                                            </span>
                                        </div>
                                        <FieldArray name={`blocks.${blockIndex}.floors`}>
                                            {({ push, remove }) => (
                                                <>
                                                    {block.floors.map((floor: any, floorIndex: any) => (
                                                        <div className='mt-3'>
                                                            <div key={floorIndex}>
                                                                <div className='d-flex'>
                                                                    <span className='font-inter' style={{ fontWeight: 600, fontSize: '16px', lineHeight: '25.6px', marginLeft: '10px' }}>
                                                                        Floor - {floorIndex + 1}
                                                                    </span>
                                                                </div>
                                                                <div className='d-flex justify-content-between mt-2'>
                                                                    <div className='col-sm-3 px-2 py-3'>
                                                                        <BpaCommonSelector
                                                                            title={t('OC_FLOOR_TYPE', 'Floor Type')}
                                                                            options={FLOOR_TYPES}
                                                                            isDisabled={true}
                                                                            field={`blocks.${blockIndex}.floors.${floorIndex}.floorType`}
                                                                        />
                                                                    </div>
                                                                    <div className='col-sm-3 px-2 py-3'>
                                                                        <GenericCommonTextField
                                                                            title={t('OC_FLOOR_NUMBER', 'Floor Number')}
                                                                            isDisabled={true}
                                                                            field={`blocks.${blockIndex}.floors.${floorIndex}.floorNumber`}
                                                                            type={'number'}
                                                                        />
                                                                    </div>
                                                                    <div className='col-sm-3 px-2 py-3'>
                                                                        <GenericCommonTextField
                                                                            title={t('OC_FLOOR_AREA', 'Floor Area')}
                                                                            isDisabled={true}
                                                                            field={`blocks.${blockIndex}.floors.${floorIndex}.floorArea`}
                                                                            type={'number'}
                                                                        />
                                                                    </div>
                                                                    <div className='col-sm-3 px-2 py-3'>
                                                                        <>
                                                                            <GenericCommonTextField
                                                                                title={t('OC_BUILT_UP_AREA', 'Built Up Area')}
                                                                                isDisabled={true}
                                                                                field={`blocks.${blockIndex}.floors.${floorIndex}.builtUpArea`}
                                                                                isRequired={true}
                                                                                type={'number'}
                                                                            />
                                                                        </>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </FieldArray>
                                    </div>
                                </div>
                            ))}
                        <hr></hr>
                    </>
                )}
            </FieldArray>
        </Form>
    );
};
